import { Card, CardBody, Modal } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import Customers from "../../pages/Customers"; // Import Customers component
import "./viewModal.css"

import moment from 'moment-timezone';

import API from '../../../../services/api';
export default function CustomerViewModal(props) {
  // Props

  const { open, handleCloseModal } = props

  return (
    <Modal
      className="modal-dialog-centered customer-view-modal"
      isOpen={open}
      toggle={handleCloseModal}
      size='lg'
    >
      <div className="modal-header">
        <h3 className="modal-title" id="exampleModalLabel">
          Customer List
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleCloseModal}
        >
          <span aria-hidden={true}><FontAwesomeIcon icon={faXmark} size="sm" /></span>
        </button>
      </div>
      <div className="modal-body p-0" >
        <Card className="border-0">
          <CardBody>
                <Customers />
          </CardBody>
        </Card>
      </div>
      <div className="modal-footer pt-2">

      </div>
    </Modal>
  )
}
